<template>
  <div class="wrap">
    <div class="message"><span>Please scroll.</span></div>
    <div class="fixedBottomBtn js-fixedBottomBtn">
      <div class="fixedBottomBtn__btn">
        <a href=""><span>povo1.0の方はこちら</span></a>
      </div>
    </div>
  </div>
</template>

<script>
import FixedBottomBtn from "./FixedBottomBtn/Controller.es6";
import $ from "jquery";
export default {
  components: {},
  created: function() {},
  mounted: function() {
    $(window).on("loaded", event => {
      new FixedBottomBtn();
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wrap {
  padding: 50px;
  height: 500vh;

  @include max(768) {
    padding: 30px;
  }
}

.message {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fixedBottomBtn {
  pointer-events: auto;
  position: fixed;
  left: 0;
  bottom: 0;
  background-color: #464749;
  width: 100%;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 12.5px;
  padding-bottom: 12.5px;
  transform: translateY(110%);

  @include max(768) {
    padding-left: 30px;
    padding-right: 30px;
    box-sizing: border-box;
  }
}

.fixedBottomBtn__btn {
  width: 500px;
  height: 80px;
  border-radius: 40px;
  background-color: #fffa00;

  @include max(768) {
    width: 100%;
  }

  a {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  span {
    color: #242424;
    font-size: 19px;
    font-weight: 600;
  }
}

.btn-primary {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  // background-color: #fffa00;
  width: 500px;
  height: 80px;
  // filter: drop-shadow(0px 3px 0px #e6e573);
  // border-radius: 40px;
  // @include rem(21.5);
  // font-weight: bold;
  // display: inline-block;

  @include media-max("sp") {
    @include rem(16.5);
    height: 60px;
    width: 90%;
  }

  .btn01 {
    &__txtwrap {
      overflow: hidden;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
      width: 100%;
    }

    &__txt {
      width: 100%;
      display: flex;
      flex-direction: column;
      text-align: center;
      @include rem(21.5);
      font-weight: bold;

      @include media-max("sp") {
        @include rem(16.5);
      }
    }

    &__bg {
      position: relative;
      display: block;
      height: 100%;
      width: 100%;
      border-radius: 40px;
      background-color: #fffa00;
      // filter: drop-shadow(0px 3px 0px #e6e573);
      box-shadow: 0px 3px 0px #e6e573;
    }
  }

  &.is-sml {
    width: 265px;
    height: 43px;

    @include media-max("sp") {
      width: 100%;
    }

    span {
      @include rem(13);
    }

    .btn-arrow {
      width: 23px;
      height: 23px;
      right: 10px;
    }

    .btn-arrow-img {
      width: 6px;
      height: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/compornent/_index.vue